import React, {useState} from "react";
import AddTrip from "../AddTrip";
import TripDetailsContent from "./TripDetailsContent";
import { useTripContext } from "./TripContext";
import "../../css/TripDetails.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import PriorityPopup from "./PriorityPopup";

const TripDetails = () => {
  const { tripData, updateTripDataByObject, error } = useTripContext();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [showPriorityPopup, setShowPriorityPopup] = useState(false);
  const handleRegistrationsClick = () => {
    navigate("registrations");
  };

  const handlePriorityClick = () => {
    setShowPriorityPopup(true);
  };

  const handleClosePriorityPopup = () => {
    setShowPriorityPopup(false);
  };

  const isEditing = searchParams.get("edit") === "true";

  const handleEditClick = () => {
    setSearchParams({ edit: "true" }); 
  };

  const handleCancelEdit = () => {
    searchParams.delete("edit"); 
    setSearchParams(searchParams);
  };

  const handleInsuranceClick = () => {
    navigate("insurances");
  };

  const handleAttendanceClick = () => {
    navigate("participants");
  };

  const handleDiscordClick = () => {
  navigate("discord");
};

  const handleAccessClick = () => {
    navigate("access");
  };

  const handleSummary = () => {
    navigate("summary");
  };


  const handleVariantClick = (variantGuid) => {
    navigate(`variants/${variantGuid}`);
  };

  if (error || !tripData) {
    return (
      <div className="error">
        {error ? (
          <p>Błąd: {error}</p>
        ) : (
          <p>Nie znaleziono wycieczki lub brak dostępu do zasobu.</p>
        )}
      </div>
    );
  }

  return (
    <div>
      {isEditing ? (
        <AddTrip
          initialData={tripData}
          onSaveTrip={(updatedTrip) => {
            updateTripDataByObject(updatedTrip);
            handleCancelEdit();
          }}
          onCancelEdit={handleCancelEdit}
        />
      ) : (
        <>
          <TripDetailsContent
            onEditClick={handleEditClick}
            onVariantClick={handleVariantClick}
            onRegistrationsClick={handleRegistrationsClick}
            onAttendanceClick={handleAttendanceClick}
            onAccessClick={handleAccessClick}
            onInsuranceClick={handleInsuranceClick}
            onPriorityClick={handlePriorityClick}
            onSummaryClick={handleSummary}
            onDiscordClick={handleDiscordClick}
            tripGuid={tripData.guid}
          />
          {showPriorityPopup && (
            <PriorityPopup onClose={handleClosePriorityPopup} tripGuid={tripData.guid} />
          )}
        </>
      )}
    </div>
  );
};

export default TripDetails;
